<script setup lang="ts">
    const {revert = false} = defineProps<{
        revert?: boolean;
    }>();
</script>

<template>
    <div class="mui-c-tag mui-border-solid" :class="revert ? 'mui-c-tag--revert mui-background--revert' : 'mui-background'" data-testid="mui-tag">
        <slot />
    </div>
</template>

<style lang="scss">
    .mui-c-tag {
        width: max-content;
        padding: var(--joy-core-spacing-1) var(--joy-core-spacing-2);
        color: var(--mui-color-text);
        font-weight: var(--joy-font-weight-bold);
        letter-spacing: var(--joy-font-letter-spacing-tight);
        font-size: var(--joy-font-size-primary-400);

        &--revert {
            color: var(--mui-color-text-revert);
            border-color: var(--mui-color-background-revert);
        }
    }
</style>
